import React from 'react';
import Classes from './SellerContactOptions.scss';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { TSellerProfileClient } from 'types/TSellerProfile';

type TCallAvailabilityIndicatorProps = {
  availableForCallingUntil: TSellerProfileClient['availableForCallingUntil'];
};

const CallAvailabilityIndicator = ({ availableForCallingUntil }: TCallAvailabilityIndicatorProps) => {
  return (
    <div className={Classes.callAvailabilityIndicator}>
      <Trans className={Classes.highlight} i18nKey={'sellerContact.callAvailability.available'} tagName="span" />
      <Trans i18nKey={'sellerContact.callAvailability.until'} tagName="span" />
      {availableForCallingUntil}
    </div>
  );
};

export default CallAvailabilityIndicator;
